export default __webpack_public_path__ + "static/media/streamer_avatar2.3b91eda6.png";